import { Component, Inject, ViewEncapsulation, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Estado } from '../models/estado';
import { Cidade } from '../models/cidade.model';
import { Endereco } from '../models/endereco.model';
import { CepService } from '../cep.service';
import { Util } from '../../../../utils/util';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../shared/EventTypes';

@Component({
	selector: 'app-cep-modal',
	templateUrl: './cep-modal.component.html',
	styleUrls: ['./cep-modal.component.styl'],
})
export class CepModalComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public disabled = true;
	public states: Estado[] = [];
	public citys: Cidade[] = [];
	public adresses: Endereco[] = [];

	constructor(
		public dialogRef: MatDialogRef<CepModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private formBuilder: FormBuilder,
		private cepService: CepService,
	) {	}

	ngOnInit(): void {
		this.getStates();
		this.initForm();
	}

	initForm() {
		this.form = this.formBuilder.group({
			uf: ['', Validators.required],
			cidade: ['', Validators.required],
			endereco: ['', Validators.required],
			bairro: [''],
		});
	}

	submit() {
		const cidade = this.form.get('cidade').value;
		const uf = this.form.get('uf').value;
		const logradouro = this.form.get('endereco').value;
		const bairro = this.form.get('bairro').value;

		this.cepService.enderecosPorQuery(cidade, uf, logradouro, bairro).subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.adresses = Util.keysToCamel(data.Retorno) as Endereco[];
				this.dialogRef.close(this.adresses);
			} else {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Nenhum endereço não encontrado para os dados informados.' });
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Endereço não encontrado.' });
		});
	}

	close(): void {
		this.dialogRef.close();
	}

	getStates(){
		this.cepService.estados().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.states = Util.keysToCamel(data.Retorno) as Estado[];
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro ao consultar os Estados, tente novamente mais tarde.' });
		});
	}

	getCitys(uf: string){
		if (uf) {
			this.cepService.cidadesPorUf(uf).subscribe(data => {
				if (data.Sucesso && data.Existe) {
					this.citys = Util.keysToCamel(data.Retorno) as Cidade[];
				}
			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro ao consultar as Cidades, tente novamente mais tarde.' });
			});
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/collection/modal-cep/modal-find/cep-modal.component.ts